import { FC } from "react";

import Skeleton from "../Skeleton/Skeleton";
import TableSkeleton from "../Table/TableSkeleton";

import styles from "./CardDailyPrompt.module.css";



const CardDailyPromptSkeleton: FC = () => {
  return (
    <>
      <div className={styles.root}>
        <div className={styles.header}>
          <h3 className={styles.title}><Skeleton height={40} width={400} variant="text" /></h3>
          <div className={styles.info}>
            <div className={styles.infoLabel}><Skeleton height={24} width={161} variant="text" /></div>
            <div className={styles.value}><Skeleton height={56} width={88} /></div>
          </div>
        </div>
      </div>

      <TableSkeleton 
        rows={5}
        columns={3}
      />
    </>
  )
};

export default CardDailyPromptSkeleton;